import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {VideoDetail} from "../../models/video";
import {environment} from "../../../environments/environment";
import videojs from 'video.js';
import { LogsService } from 'src/app/services/logs.service';

@Component({
  selector: 'app-card-video',
  templateUrl: './card-video.component.html',
  styleUrls: ['./card-video.component.scss']
})
export class CardVideoComponent implements OnInit {
  urlApi = environment.urlApiVideos.url;
  options = {
    autoplay: false,
    controls: false,
    sources: [
      {
        src: '',
        type: 'video/mp4'
      }
    ]
  };
  @ViewChild('idVideo', {static: true}) idVideo: ElementRef;
  player: videojs.Player;
  user_id:string;

  constructor(private logService:LogsService) { }

  ngOnInit(): void {
    this.user_id = localStorage.getItem('user_id');
    let src_video = environment.urlApiVideos.url+'/api/filevideo/descargar?videoName='+this.video.NombreArchivo+"&UserID="+this.user_id
    this.options.sources[0].src = src_video;
    this.player = videojs(this.idVideo.nativeElement, this.options, function onPlayerReady() {
      console.log('onPlayerReady', this);
      this.play()
      this.currentTime(10)
      this.pause()
    })
    this.player.on('error', () => {
      console.log(this.player.error());
      if(this.player.error().code == 4){
        console.log('error 4');
        this.logService.createLogErrorDireccion(`No se encuentra grabación`,this.video.GrabacionCod,this.video.RutaDecodificado,this.video['Almacenamiento'],4).subscribe({
          next:res=>{
            console.log(res);
          },
          error:err=>console.error(err)
        })

      }
      if(this.player.error().code == 3) console.log('error 3');
    });
  }
  @Input('video') video: VideoDetail
  @Input("ProcedureValue") ProcedureValue

}
